"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationDrawer = void 0;
var Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
var react_1 = __importDefault(require("react"));
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var core_1 = require("@material-ui/core");
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var cs_short_logo_white_svg_1 = __importDefault(require("../../assets/images/cs_short_logo_white.svg"));
var cs_text_white_svg_1 = __importDefault(require("../../assets/images/cs_text_white.svg"));
var lr_short_logo_svg_1 = __importDefault(require("../../assets/images/lr_short_logo.svg"));
var lr_text_svg_1 = __importDefault(require("../../assets/images/lr_text.svg"));
var beko_white_01_svg_1 = __importDefault(require("../../assets/images/beko_white_01.svg"));
var empty_svg_1 = __importDefault(require("../../assets/images/empty.svg"));
var Button_1 = __importDefault(require("@material-ui/core/Button/Button"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip/Tooltip"));
var NavigationDrawerStyles_1 = require("./NavigationDrawerStyles");
exports.NavigationDrawer = react_1.default.memo(function (_a) {
    var _b, _c;
    var onDrawerAction = _a.onDrawerAction, entries = _a.entries, onLinkClicked = _a.onLinkClicked, activeLink = _a.activeLink;
    var _d = react_1.default.useState(false), open = _d[0], setOpen = _d[1];
    var classes = NavigationDrawerStyles_1.useStyles();
    var t = react_i18next_1.useTranslation('common').t;
    var theme = core_1.useTheme();
    var logo = cs_short_logo_white_svg_1.default;
    var logo_text = cs_text_white_svg_1.default;
    if (theme.mixins.themeStyle.theme === 'neutralLight') {
        logo = lr_short_logo_svg_1.default;
        logo_text = lr_text_svg_1.default;
    }
    if (theme.mixins.themeStyle.theme === 'bekoLight') {
        logo = beko_white_01_svg_1.default;
        logo_text = empty_svg_1.default;
    }
    var handleDrawerOpen = function () {
        setOpen(true);
        onDrawerAction(true);
    };
    var handleDrawerClose = function () {
        setOpen(false);
        onDrawerAction(false);
    };
    return (react_1.default.createElement(Drawer_1.default, { variant: "permanent", className: clsx_1.default(classes.drawer, (_b = {},
            _b[classes.drawerOpen] = open,
            _b[classes.drawerClose] = !open,
            _b)), classes: {
            paper: clsx_1.default((_c = {},
                _c[classes.drawerOpen] = open,
                _c[classes.drawerClose] = !open,
                _c[classes.paper] = true,
                _c)),
        } },
        react_1.default.createElement("div", { style: NavigationDrawerStyles_1.drawerTop },
            react_1.default.createElement(Button_1.default, { className: classes.drawerButton, variant: "text", size: 'large', startIcon: react_1.default.createElement(react_1.default.Fragment, null, open ? (react_1.default.createElement(ChevronLeft_1.default, { className: classes.drawerText })) : (react_1.default.createElement(ChevronRight_1.default, { className: classes.drawerText }))), onClick: open ? handleDrawerClose : handleDrawerOpen },
                react_1.default.createElement("img", { alt: "logo", src: logo, height: "36" }),
                open && react_1.default.createElement("img", { style: { marginLeft: 6, marginTop: 10 }, alt: "logo", src: logo_text, height: "10" }))),
        react_1.default.createElement(List_1.default, null, entries.map(function (entry) {
            var selected = activeLink === entry.link;
            return (react_1.default.createElement(ListItem_1.default, { classes: { selected: classes.selected }, selected: selected, button: true, key: entry.text, onClick: function () { return onLinkClicked(entry.link); }, style: open ? NavigationDrawerStyles_1.listItemOpen : NavigationDrawerStyles_1.listItem },
                react_1.default.createElement(ListItemIcon_1.default, null,
                    !open && (react_1.default.createElement(Tooltip_1.default, { placement: 'right-start', title: t(entry.text) },
                        react_1.default.createElement(entry.Icon, { className: selected ? classes.drawerTextSelected : classes.drawerText }))),
                    open && react_1.default.createElement(entry.Icon, { className: selected ? classes.drawerTextSelected : classes.drawerText })),
                react_1.default.createElement(ListItemText_1.default, { disableTypography: true, primary: open ? react_1.default.createElement(core_1.Typography, { variant: 'subtitle1' }, '\u00A0' + t(entry.text)) : undefined })));
        }))));
});
exports.NavigationDrawer.displayName = 'NavigationDrawer';
exports.default = exports.NavigationDrawer;
//# sourceMappingURL=NavigationDrawer.js.map